import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AvatarModule } from '../../avatar';
import { DataListModule } from '../../data-list';
import { AutoSearchModule } from '../../autosearch';
import { DateModule } from '../../date';
import { PipeModule } from '../../pipes';
import { ActionCoCardComponent } from './action-co-card.component';
import { ActionCoActionComponent } from './action-co-action/action-co-action.component';
import { ActionCoMailComponent } from './action-co-mail/action-co-mail.component';
import { ActionCoDevisComponent } from './action-co-devis/action-co-devis.component';
import { ActionCoLDMComponent } from './action-co-ldm/action-co-ldm.component';
import { ActionCoCalculatorComponent } from './action-co-calculator/action-co-calculator.component';
import { ActionCoCacComponent } from './action-co-cac/action-co-cac.component';
import { ActionCoESignComponent } from './action-co-esign/action-co-esign.component';
import { ActionCoBoComponent } from './action-co-bo/action-co-bo.component';
import { ActionCoTransformComponent, SelectionStageTitlePipe } from './action-co-transform/action-co-transform.component';
import { BodisplayModule, DynamicTagModule, DynamicTagGroupModule } from '../../bodisplay';
import { AvatarSearchModule } from '../../avatar-search';
import { ESignatureModule } from '../../esignature/esignature.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InputListComponent, FilterPipe } from './action-co-mail/input-list/input-list.component';
import { CustomgridModule } from '../../customgrid';
import { GEDModule } from '../../gestion-electronique-documents';
import { InsertDocModule } from '../../insertdoc';
import { TagModule } from '../../tag';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ConditionModule } from '../../conditions';
import { ActionCoService } from './action-co-services/action-co.service';
import { ActionCoHistoService } from './action-co-services/action-co-histo.service';
import { CalculatorViewComponent } from './action-co-calculator/calculator-view/calculator-view.component';
import { ActionCoCalculatorService } from './action-co-services/action-co-calculator.service';
import { CalculatorConfigComponent, FilterObligation, FilterProperty } from './action-co-calculator/calculator-config/calculator-config.component';
import { CalculatorCalculComponent } from './action-co-calculator/calculator-calcul/calculator-calcul.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    AvatarModule,
    DataListModule,
    DateModule,
    AutoSearchModule,
    PipeModule,
    BodisplayModule,
    DynamicTagModule,
    DynamicTagGroupModule,
    AvatarSearchModule,
    ESignatureModule,
    CKEditorModule,
    CustomgridModule,
    GEDModule,
    InsertDocModule,
    TagModule,
    ScrollingModule,
    ConditionModule
  ],
  declarations: [
    ActionCoCardComponent,
    ActionCoActionComponent,
    ActionCoMailComponent,
    ActionCoDevisComponent,
    ActionCoLDMComponent,
    ActionCoCalculatorComponent,
    CalculatorViewComponent,
    CalculatorConfigComponent,
    CalculatorCalculComponent,
    ActionCoCacComponent,
    ActionCoESignComponent,
    ActionCoBoComponent,
    ActionCoTransformComponent,
    InputListComponent,
    SelectionStageTitlePipe,
    FilterPipe,
    FilterObligation,
    FilterProperty
  ],
  exports: [
    ActionCoCardComponent,
    ActionCoActionComponent,
    ActionCoMailComponent,
    ActionCoDevisComponent,
    ActionCoLDMComponent,
    ActionCoCalculatorComponent,
    CalculatorViewComponent,
    CalculatorConfigComponent,
    CalculatorCalculComponent,
    ActionCoCacComponent,
    ActionCoESignComponent,
    ActionCoBoComponent,
    ActionCoTransformComponent
  ],
  providers: [
    ActionCoService,
    ActionCoHistoService,
    ActionCoCalculatorService,
  ],
})
export class ActionCoCardModule { }
